import { FC, JSX, ReactElement, ReactNode } from "react";
import Swal, { SweetAlertIcon } from "sweetalert2";
import withReactContent, {
  ReactSweetAlertOptions,
} from "sweetalert2-react-content";

export const MySwal = withReactContent(Swal);

export const infoAlert = (
  title: string,
  footer: string | ReactElement<any, any>
) =>
  MySwal.fire({
    title,
    icon: "info",
    footer,
  });

export const successAlert = (title: string) =>
  MySwal.fire({
    title,
    icon: "success",
    showConfirmButton: false,
    timer: 1500,
  });

export const warningAlert = (
  title: string,
  html: string | ReactElement<any, any>,
) =>
  MySwal.fire({
    title: `<div style="line-height: 1.2;overflow-y: hidden;margin-bottom:12px;text-transform: uppercase;font-size: 22px;">${title}</div>`,
    html: `<div style="line-height: 1.2;overflow-y: hidden;">${html}</div>`,
    icon: "warning",
  });

export const errorAlert = (title: string, text: string, footer: any) =>
  MySwal.fire({
    icon: "error",
    title,
    text,
    footer,
  });

export const confirmationAlert = async (
  title: string,
  text: string,
  confirmButtonText: string
): Promise<boolean> => {
  const res = await MySwal.fire({
    title,
    text,
    icon: "warning",
    confirmButtonColor: "#3085d6",
    cancelButtonColor: "#d33",
    confirmButtonText,
    cancelButtonText: "Cancelar",
    showCancelButton: true,
    denyButtonText: "Cancelar",
  });

  return res.isConfirmed;
};

interface ConfirmationLoadingParams {
  title: string;
  text: string;
  confirmButtonText: string;
  setLoading: React.Dispatch<React.SetStateAction<boolean>>;
}

//Alert que devuelve el estado del componente loading del padre
export const confirmationLoading = async ({
  title,
  text,
  confirmButtonText,
  setLoading,
}: ConfirmationLoadingParams): Promise<boolean> => {
  const res = await MySwal.fire({
    title,
    text,
    icon: "warning",
    confirmButtonColor: "#3085d6",
    cancelButtonColor: "#d33",
    confirmButtonText,
    cancelButtonText: "Cancelar",
    showCancelButton: true,
  });

  if (res.isConfirmed) {
    setLoading(true); // Activa el estado para mostrar el Loading.
  }

  return res.isConfirmed; // Retorna si se confirmó o no.
};

export const confirmationAlertHtml = async (
  children: JSX.Element,
  confirmButtonColor: string = "#3085d6",
  confirmButtonText: string = "Confirmar",
  cancelButtonColor: string = "#d33",
  cancelButtonText: string = "Cancelar",
  width: string = "50%",
  iconParam: SweetAlertIcon | undefined = "warning"
): Promise<boolean> => {
  const res = await MySwal.fire({
    html: children,
    icon: iconParam,
    confirmButtonColor,
    confirmButtonText,
    cancelButtonColor,
    cancelButtonText,
    showCancelButton: true,
    denyButtonText: "Cancelar",
    width,
  });

  return res.isConfirmed;
};

export const Modal = (
  children: JSX.Element,
  options: ReactSweetAlertOptions
) => {
  MySwal.fire({
    ...options,
    html: children,
  });
};

